import React, { ComponentProps, useRef } from "react";
import BoundingBox from "frontend/geometry/bounding-box";
import Konva from "konva";
import { measureNodesScreenSpace } from "utils/node-utils";
import { GanttConnectorToolbar } from "elements/gantt/components/gantt-connector/gantt-connector-toolbar";
import SimpleConnector from "frontend/canvas-designer-new/elements/connector/simple-connector";

type GanttConnectorProps = {
  removeConnector: () => void;
  isSelected: boolean;
} & ComponentProps<typeof SimpleConnector>;

export const GanttConnector = ({ removeConnector, isSelected, ...ghostConnectorProps }: GanttConnectorProps) => {
  const shapeRef = useRef<Konva.Shape>(null);

  const cellBbox: BoundingBox | null =
    shapeRef.current && BoundingBox.expandOnAll(measureNodesScreenSpace([shapeRef.current], { skipStroke: true }));

  return (
    <>
      <SimpleConnector {...ghostConnectorProps} ref={shapeRef} />
      {isSelected && cellBbox && <GanttConnectorToolbar cellBbox={cellBbox} removeConnector={removeConnector} />}
    </>
  );
};
